import './components/request-demo';
import './components/scroll';
import './components/videos';
import './components/inputs';
window.animationTestimonials = jQuery('.slider-testimonials').slick({
  //infinite: true,
  centerPadding: '200px',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  //autoplay: true,
  autoplaySpeed: 5000,
  centerMode: true,
  dots: true,
  responsive: [
    {
      breakpoint: 1100,
      settings: {
        centerPadding: '0px',
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '50px',
      }
    },
    {
      breakpoint: 501,
      settings: {
        centerPadding: '0px',
      }
    }
  ]
});
window.inAnimationTestimonials = false;
jQuery(window).on("scroll", validateIfAnimation);
function validateIfAnimation() {
  if (window.inAnimationTestimonials) {
    return;
  }
  const testimonials = jQuery('.slider-testimonials');
  for (let index = 0; index < testimonials.length; index++) {
    const element = testimonials[index];
    const position = element.getBoundingClientRect().top;

    if (position < 0) {
      window.animationTestimonials.slick('slickPlay');
      window.inAnimationTestimonials = true;
      jQuery(window).off('scroll');
      break;
    }
  }
}
jQuery(window).on('resize', validateWindow);
function validateWindow() {
  const widthWindow = window.innerWidth;
  const widthSpace = 1100;
  let padding = 0;
  if (widthWindow > widthSpace) {
    padding = (widthWindow - widthSpace) / 2;
    
    window.animationTestimonials.slick('slickSetOption','centerPadding', `${padding}px`);
  }
}
validateWindow();
jQuery('.slider-cases').slick({
  infinite: true,
  centerPadding: '160px',
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        arrows: true
      }
    },
    {
      breakpoint: 501,
      settings: {
        arrows: false
      }
    }
  ]
});
jQuery('.slider-benefits-for').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  // fade: true,
  asNavFor: '.slider-benefits-nav'
});
jQuery('.slider-benefits-nav').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: '.slider-benefits-for',
  focusOnSelect: true,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    },
    {
      breakpoint: 501,
      settings: {
        arrows: false,
        centerPadding: '40px',
        slidesToShow: 2,
        slidesToScroll: 1,
      }
    }
  ]
});


//import

function animate() {
  const nameClassAnimate = 'animate';
  const elements = jQuery('.' + nameClassAnimate);
  for (let index = 0; index < elements.length; index++) {
    const elementJquery = jQuery(elements[index]);
    const listClass = elements[index].classList;
    let animationDefault = "fade-up";
    for (let i = 0; i < listClass.length; i++) {
      const nameClass = listClass[i];
      if (nameClass.indexOf('aos') >= 0) {
        animationDefault = nameClass.replace("aos-", '');
        break;
      }
    }
    elementJquery.data(
      "aos", animationDefault
    );
    elementJquery.attr({ "data-aos": animationDefault, "data-aos-duration": "1000" });
  }
  AOS.init();
}
animate();

function transfromULToSelect() {
  jQuery(".component-menu-header__langs").click(function (evt) {

    var is_open = jQuery(this).hasClass("open");
    if (is_open) {
      jQuery(this).removeClass("open");
    } else {
      jQuery(this).addClass("open");
    }
  });
  const currentLang = jQuery(jQuery(".component-menu-header__langs .current-lang")[0]);
  jQuery(".component-menu-header__langs").prepend(currentLang);
  jQuery(".component-menu-header__langs li").click(function () {

    var selected_value = jQuery(this).html();
    var first_li = jQuery(".component-menu-header__langs li:first-child").html();

    jQuery(".component-menu-header__langs li:first-child").html(selected_value);
    jQuery(this).html(first_li);

  });

  jQuery(document).mouseup(function (event) {

    var target = event.target;
    var select = jQuery(".component-menu-header__langs");

    if (!select.is(target) && select.has(target).length === 0) {
      select.removeClass("open");
    }

  });
}

jQuery('.wp-element-button').on('click', function(evt) {
  const button = jQuery(this);
  const rel = button.attr("rel");
  const href = button.attr("href");
  if(!href && rel) {
      window.open(rel, "_top");
  }
});
transfromULToSelect();